module.exports = __webpack_public_path__ + "img/vertical-flip.55d9fb84.svg";